import type { GenericLayer, LayerType } from "../../types";
import { landAssemblyClickResolver } from "../../selectionUtils";

import { SitesSelectionSidebar } from "./SitesSelectionSidebar";
import { SiteRightClickMenu } from "./SitesRightClickMenu";
import { sitesClickResolver } from "./sitesClickResolver";
import { SitesControlPage } from "./ControlPage";
import { SitesMapLayer } from "./SitesMapLayer";

export type SitesLayer = GenericLayer<{
  captureInternalPolygonClicks?: boolean;
}>;

export const SitesLayerType: LayerType = {
  id: "sites",
  SelectionSidebar: SitesSelectionSidebar,
  MapLayer: SitesMapLayer,
  clickResolver: sitesClickResolver,
  RightClickMenu: SiteRightClickMenu,
  landAssemblyClickResolver: landAssemblyClickResolver(sitesClickResolver),
  ControlPage: SitesControlPage,
};
